import easyDialog from '@/lib/easy-dialog'
import { AjaxCouponClippedHeader } from './coupon'
import { ready } from '@/lib/ready'
import { getUrlParameter } from '@/lib/utils'
import { isVisible } from '@/lib/dom/isVisible'
import { on } from '@/lib/dom/on'

function getDefaultClipCouponHTML() {
  const ccHtml = `
  <div type="text/template" id="ClipCouponDialogBox" style="display: none;">
      <div class="easyDialog_wrapper" id="divClipCouponreturn" style="margin: 0px; top: 200px; background-color: white; display: block;border-radius: 15px;">
           <style>
          .clipped-coupon {
              background-color: #fff;
              border-radius: 15px;
              width: 690px;
              padding: 0;
              position: relative;
              overflow: hidden;
          }

          .clipped-coupon .close_btn {
              font-size: 14px;
              position: absolute;
              right: 10px;
              top: 10px;
              width: 25px;
              height: 25px;
              background: rgba(255, 255, 255, .3);
              border-radius: 25px;
              color: #4d4d4d;
              text-align: center;
              line-height: 25px;
          }

          .clipped-coupon .close_btn:hover {
              background: rgba(255, 255, 255, .7);
              color: #000;
          }

          .clipped-coupon__content {
              display: flex;
              align-items: center;
              text-align: center;
              line-height: 1.2;
              font-size: 19px;
              color: #666;
              font-family: "Poppins Regular", Helvetica, Arial, sans-serif;
          }

          .clipped-coupon p {
              font-size: 24px;
              color: #374466;
              margin-bottom: 15px;
              overflow: hidden;
          }

          .clipped-coupon b,
          .clipped-coupon em {
              font-family: "Poppins Bold", Helvetica, Arial, sans-serif;
              font-weight: 500;
          }

          .clipped-coupon b {
              font-size: 24px;
              color: #374466;
              display: block;
              margin-top: 15px;
          }

          .clipped-coupon em {
              color: #5d8ef9;
              font-style: normal;
          }

          .clipped-coupon__tips {
              font-size: 12px;
              color: #808080;
              display: block;
              white-space: pre-line;
          }

          .clipped-coupon figure {
              margin: 0;
              width: 311px;
              height: 366px;
          }

          .clipped-coupon__left {
              padding: 0 30px;
          }

          .clipped-coupon__button {
              width: 267px;
              height: 45px;
              border-radius: 45px;
              background-color: #e56312;
              color: #fff;
              border: 0;
              cursor: pointer;
              font-size: 16px;
              margin: 20px 0;
          }

          .clipped-coupon__button:hover {
              background-color: #cd4d08;
          }

          @media (max-width:800px) {
              .clipped-coupon {
                  width: 100%;
              }

              .clipped-coupon__left {
                  width: calc(100% - 311px);
                  padding: 30px 15px 15px 15px;
              }

              .clipped-coupon__content {
                  font-size: 15px;
              }

              .clipped-coupon p,
              .clipped-coupon b {
                  font-size: 20px;
              }

              .clipped-coupon__button {
                  width: 220px;
              }
          }

          @media (max-width:600px) {
              .clipped-coupon__content {
                  display: block;
              }

              .clipped-coupon__left {
                  width: 100%;
              }

              .clipped-coupon figure {
                  margin: 15px auto;
              }
          }
      </style>
      <div class="clipped-coupon">
          <a href="javascript:;" title="close" class="close_btn" id="closeBtn" data-close="">X</a>
          <div class="clipped-coupon__content">
              <div class="clipped-coupon__left">
                  <p id="couponClipCodeHeadLine"></p>
                  <span>We've added a coupon code to use at checkout: <em id="couponClipCodeTxt"></em></span>
                  <b id="couponClipCodeDesc"></b>
                  <button type="button" class="clipped-coupon__button">Continue Shopping ></button>
                  <span class="clipped-coupon__tips"><span id="couponClipCodeTips"></span>Some exclusions apply.</span>
              </div>
              <figure><img src="https://img66.anypromo.com/frontimg/2024/Coupon/clipped-coupon.jpg"
                      alt="Clipped Coupon" width="311" height="366"></figure>
          </div>
      </div>
      </div>
  </div>`
  return ccHtml
}

function getLuckyDayClipCouponHTML(cp: string) {
  let LuckyDayImageURL = ''
  if (cp === 'LUCKYDAY15ES') {
    LuckyDayImageURL = 'https://img66.anypromo.com/frontimg/2025/Popup/LUCKYDAY15ES.gif'
  } else if (cp === 'LUCKYDAY15E') {
    LuckyDayImageURL = 'https://img66.anypromo.com/frontimg/2025/Popup/LUCKYDAY15E.gif'
  } else {
    LuckyDayImageURL = 'https://img66.anypromo.com/frontimg/2025/Popup/LUCKYDAY15H.gif'
  }
  const ccHtml = `
             <div type="text/template" id="ClipCouponDialogBox" style="display: none;">
                 <div class="LuckyWheel-outer" id="divClipCouponreturn">
                      <style>
                        .LuckyWheel {
                            width: 651px;
                            height: 660px;
                            position: relative;
                            margin: 0 auto;
                        }

                        .LuckyWheel .close_btn {
                            font-size: 14px;
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            width: 25px;
                            height: 25px;
                            background: rgba(255, 255, 255, .5);
                            border-radius: 25px;
                            color: #4d4d4d;
                            text-align: center;
                            line-height: 25px;
                        }

                        .LuckyWheel .close_btn:hover {
                            background: rgba(255, 255, 255, 1);
                            color: #000;
                        }

                        .LuckyWheel .btn {
                            position: absolute;
                            right: 263px;
                            bottom: 69px;
                            width: 125px;
                            height: 44px;
                            background: rgba(0, 0, 0, 0);
                            border-radius: 44px;
                            display: block;
                            border:0;
                            font-size: 0;
                            cursor: pointer;
                        }

                        .LuckyWheel .btn:hover {
                            background: rgba(0, 0, 0, .2);
                        }

                        .LuckyWheel figure {
                            width: 651px;
                            height: 660px;
                            margin: 0;
                        }

                        @media (max-width:650px) {
                            .LuckyWheel {
                                width: 100vw;
                                height: auto;
                            }

                            .LuckyWheel .btn {
                                right: auto;
                                bottom: auto;
                                left: 50%;
                                top: 293px;
                                width: 68px;
                                height: 25px;
                                margin-left: -34px;
                            }

                            .LuckyWheel figure,
                            .LuckyWheel figure img {
                                width: 350px;
                                height: 355px;
                                margin: 0 auto;
                            }
                        }
                    </style>
                    <div class="LuckyWheel">
                        <a href="javascript:;" title="close" class="close_btn" id="closeBtn" data-close="">X</a>
                        <figure>
                            <img src="${LuckyDayImageURL}" alt="Lucky Wheel"
                                width="651" height="660">
                        </figure>
                        <button type="button" class="btn LuckyWheel__button" onclick="voidCouponDialog();">CLAIM</button>
                    </div>
                </div>
            </div>`
  return ccHtml
}

function voidCouponDialog() {
  if (document.querySelector('#easyDialogBox') && isVisible('#overlay')) {
    easyDialog.close()
  }
}

export const onPromoClick = (promoObj: any) => {
  window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: promoObj.creative,
    ecommerce: {
      ga4: {
        promotion_id: 'coupon_' + promoObj.id,
        promotion_name: 'coupon_' + promoObj.name
      },
      ua: {
        ecommerce: {
          promoView: {
            promotions: [
              // Array of promoFieldObjects.
              {
                id: 'coupon_' + promoObj.id, // Name or ID is required.
                name: 'coupon_' + promoObj.name,
                creative: promoObj.creative,
                position: promoObj.pos
              }
            ]
          }
        }
      }
    }
  })
}
export const CopyCouponCode = (couponCode: string) => {
  if (!document.querySelector('#divClipCouponreturn')) {
    document.body.insertAdjacentHTML('beforeend', getDefaultClipCouponHTML())
  }
  const url = '/Ajax/Customer.aspx/CopyCouponCode'
  const param = { couponCode: couponCode }
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(param),
    headers: {
      'content-type': 'application/json; charset=utf-8'
    }
  })
    .then((res) => res.json())
    .then((data: any) => {
      const jsonData = JSON.parse(data.d)
      if (jsonData.ReturnValue == 'Ok' || jsonData.ReturnValue == 'already') {
        const couponInfo = JSON.parse(jsonData.ReturnText)
        const couponClipCodeTxt = document.querySelector('#couponClipCodeTxt')
        if (couponClipCodeTxt) couponClipCodeTxt.textContent = couponInfo.couponCode
        const couponClipCodeHeadLine = document.querySelector('#couponClipCodeHeadLine')
        if (couponClipCodeHeadLine) couponClipCodeHeadLine.textContent = couponInfo.headLine
        const couponClipCodeDesc = document.querySelector('#couponClipCodeDesc')
        if (couponClipCodeDesc) couponClipCodeDesc.textContent = couponInfo.description
        const couponClipCodeTips = document.querySelector('#couponClipCodeTips')
        if (couponClipCodeTips) couponClipCodeTips.textContent = couponInfo.tips

        easyDialog.open({
          container: 'divClipCouponreturn'
        })
        on('#divClipCouponreturn .clipped-coupon__button', 'click', voidCouponDialog)
        AjaxCouponClippedHeader()
        onPromoClick({
          id: couponInfo.couponCode,
          name: couponInfo.couponCode,
          creative: 'clip_coupon',
          pos: 1
        })
      } else {
        alert(jsonData.ReturnText)
      }
    })
}

const CopyCouponCodeFromUrl = (couponCode: string) => {
  if (!document.querySelector('#divClipCouponreturn')) {
    if (couponCode.indexOf('LUCKYDAY15') === 0) {
      document.body.insertAdjacentHTML('beforeend', getLuckyDayClipCouponHTML(couponCode))
    } else {
      document.body.insertAdjacentHTML('beforeend', getDefaultClipCouponHTML())
    }
  }
  const url = '/Ajax/Customer.aspx/CopyCouponCode'
  const param = { couponCode: couponCode }
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(param),
    headers: {
      'content-type': 'application/json; charset=utf-8'
    }
  })
    .then((res) => res.json())
    .then((data: any) => {
      const jsonData = JSON.parse(data.d)
      if (jsonData.ReturnValue == 'Ok') {
        const couponInfo = JSON.parse(jsonData.ReturnText)
        if (couponCode.indexOf('LUCKYDAY15') === 0) {
          easyDialog.open({
            container: 'divClipCouponreturn'
          })
          on('#divClipCouponreturn .LuckyWheel__button', 'click', voidCouponDialog)
        } else {
          const couponClipCodeTxt = document.querySelector('#couponClipCodeTxt')
          if (couponClipCodeTxt) couponClipCodeTxt.textContent = couponInfo.couponCode
          const couponClipCodeHeadLine = document.querySelector('#couponClipCodeHeadLine')
          if (couponClipCodeHeadLine) couponClipCodeHeadLine.textContent = couponInfo.headLine
          const couponClipCodeDesc = document.querySelector('#couponClipCodeDesc')
          if (couponClipCodeDesc) couponClipCodeDesc.textContent = couponInfo.description
          const couponClipCodeTips = document.querySelector('#couponClipCodeTips')
          if (couponClipCodeTips) couponClipCodeTips.textContent = couponInfo.tips

          easyDialog.open({
            container: 'divClipCouponreturn'
          })
          on('#divClipCouponreturn .clipped-coupon__button', 'click', voidCouponDialog)
        }
        AjaxCouponClippedHeader()
        onPromoClick({
          id: couponInfo.couponCode,
          name: couponInfo.couponCode,
          creative: 'clip_coupon',
          pos: 1
        })
      } else if (jsonData.ReturnValue == 'already') {
        //no display
        const couponInfo = JSON.parse(jsonData.ReturnText)
        onPromoClick({
          id: couponInfo.couponCode,
          name: couponInfo.couponCode,
          creative: 'clip_coupon',
          pos: 1
        })
      } else {
        alert(jsonData.ReturnText)
      }
    })
}

ready(() => {
  const cp = getUrlParameter('cp')
  if (cp) {
    CopyCouponCodeFromUrl(cp)
  }
})
